import { Component, Input } from '@angular/core';
import { HARDCOPY_PRICE } from '../../settings';
import { formatPrice } from '../../tools';

@Component({
    selector: 'hardcopy-purchase-bar',
    templateUrl: 'purchase-bar.html',
    host: {
        class: 'purchase-bar',
    }
})

export class HardcopyPurchaseBar {

    @Input('qty') public qty: number = 1;

    constructor(

    ) {

    }

    public getPrice(): string {
        return formatPrice(HARDCOPY_PRICE * this.qty);
    }

    public getQty(): string {
        let qty = this.qty.toString();

        while (qty.length < 2) {
            qty = '0' + qty;
        }

        return qty;
    }

}



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/components/purchase-bar/purchase-bar.ts